export default __webpack_public_path__ + "static/media/124-vatican-city.49e11f90.svg";